module.exports = __webpack_public_path__ + "img/our-client-feedback-img-2.e1ccecfa.png";